import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CurrentLang } from 'common';

// eslint-disable-next-line no-unused-vars
import Chart from './Chart.bundle.js';

// import { MagstimColor } from "./../Magstim.Color";

import { init, setup, setupMulti, getSettings } from './LineChart.js'

class MagstimChartSimple extends React.Component {

	constructor(props) {
		super(props);

		this._canvasRef = React.createRef();
	}

	componentDidUpdate() {
		
		// console.log(`MagstimChartSimple.componentDidUpdate this.props=`, this.props);
		
		if (this.hasData()) {

			const canvas = document.getElementById(this.props.chartCanvasName);

			var stepSize = undefined;
			if (undefined !== this.props.yStepCount) {
				stepSize = Math.ceil((this.props.yMax - this.props.yMin) / this.props.yStepCount);
			}
			
			if(canvas === undefined || canvas.chart === undefined){
				var settings = getSettings();
				settings.options.maintainAspectRatio = this.props.maintainAspectRatio;
				
				if (undefined !== this.props.lineTension) {
					settings.options.elements.line.tension = this.props.lineTension;
				}
			
				if (undefined !== this.props.yAxesLabelString) {
					settings.options.scales.yAxes[0].scaleLabel.display = true;
					settings.options.scales.yAxes[0].scaleLabel.labelString = this.props.yAxesLabelString;
				}else{
					settings.options.scales.yAxes[0].scaleLabel.display = false;
				}

				init(this.props.chartCanvasName, settings);
			}
		
			if ((undefined !== this.props.yMin) && 
				(undefined !== this.props.yMax) && 
				(undefined !== this.props.seriesArray)) {

				if ((undefined === this.props.seriesMulti) || (!this.props.seriesMulti)) {
					setup(this.props.chartCanvasName, this.props.yMin, this.props.yMax, this.props.seriesArray);
				}
				else {
					setupMulti(this.props.chartCanvasName, this.props.yMin, this.props.yMax, this.props.seriesArray, stepSize);
				}
			}
		}
	}

	hasData = () =>{
		if ((undefined === this.props.seriesMulti) || (!this.props.seriesMulti)) {

			return (undefined !== this.props.seriesArray)
				&& (null !== this.props.seriesArray)
				&& (undefined !== this.props.seriesArray.xValues)
				&& (null !== this.props.seriesArray.xValues)
				&& (this.props.seriesArray.xValues.length >= 2)
		} 
		else {

			return (undefined !== this.props.seriesArray)
				&& (null !== this.props.seriesArray)
				&& (this.props.seriesArray.length > 0)
				&& (undefined !== this.props.seriesArray[0].xValues)
				&& (null !== this.props.seriesArray[0].xValues)
				&& (this.props.seriesArray[0].xValues.length >= 2)
				;
		}
	}

	render() {

		// console.log("MagstimChartSimple.render", this.props, this.state);

		var content;
		if (this.hasData()) {
			content = <div className={"ui-panel d-block pt-3"} >
				<canvas style={{ width: this.props.width, height: this.props.height }} ref={this._canvasRef} id={this.props.chartCanvasName} />
			</div>;
		}
		else {
			content = <NoDataChart className={"ui-panel d-block pt-3"} height={this.props.height}>
				<i className="fas fa-chart-line"></i>
				<p><strong>{CurrentLang().not_enough_data_words}</strong></p>
				<p>{this.props.noDataMessage}</p>
			</NoDataChart>;
		}

		return (
			<Wrapper>
				{content}
			</Wrapper>
		);
	}
}


const Wrapper = styled.div`
  height: 100%;
`;

const NoDataChart = styled.div`
    padding: 20px;
    min-height: ${props => props.height}px;
    text-align: center;
    vertical-align: middle;

		i {
			font-size: 90px;
		}
`;

MagstimChartSimple.propTypes = {
	width: PropTypes.number,
	height: PropTypes.any,
	yMin: PropTypes.number,
	yMax: PropTypes.number,
	yStepCount: PropTypes.number,
	seriesArray: PropTypes.any,
	noDataMessage: PropTypes.string,
	chartCanvasName:PropTypes.string,
	lineTension: PropTypes.number,
	maintainAspectRatio:PropTypes.bool,
	yAxesLabelString:PropTypes.string
};

MagstimChartSimple.defaultProps = {
	width:500,
	height:500,
	yMin: 0,
	yMax: 100,
	yStepCount: undefined,
	seriesArray: undefined,
	noDataMessage: CurrentLang().rmt_chart_no_data,
	chartCanvasName:'canvasChart',
	lineTension: undefined,
	maintainAspectRatio:false,
	yAxesLabelString:undefined
};

export default MagstimChartSimple;

